module.exports = __webpack_public_path__ + "static/media/co_fullsize_white.94407ddd.png";